import { render, staticRenderFns } from "./AccountsReceivableList.vue?vue&type=template&id=529318b0&scoped=true"
import script from "./AccountsReceivableList.vue?vue&type=script&lang=js"
export * from "./AccountsReceivableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529318b0",
  null
  
)

export default component.exports